<template>
  <div class="message-box-common flex-center" v-if="showMessageBox">
    <div class="message-box-main">
      <div class="message-box-top">
        <div class="message-box-title">
          <h4 class="flex-center">{{ title }}</h4>
          <i class="icon icon-close" @click="onShowMessageBox"></i>
        </div>
        <slot name="top"></slot>
      </div>
      <div class="message-box-content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "messageBoxC",
  props: {
    showMessageBox: Boolean,
    title: String,
  },
  methods: {
    onShowMessageBox() {
      this.$emit("update:showMessageBox", !this.showMessageBox);
    },
  },
};
</script>
<style lang="scss" scoped>
.message-box-common {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background: colorRgba(#000, 0.8);
  .message-box-main {
    // width: 560px;
    width: 480px;
    border-radius: 20px;
    background: #1e1f23;
    // border-radius: $big-border-radius;

    .message-box-top {
      padding: 24px 24px 32px;
      background-color: #2a2c32;
      border-radius: 20px;
      // border-radius: $big-border-radius $big-border-radius $big-border-radius *
      //   2 $big-border-radius * 2;

      // background-image: linear-gradient(90deg, rgb(24 238 216 / 30%) 1%, rgb(166 246 22 / 30%) 100%);
    }

    .message-box-title {
      position: relative;
      padding-bottom: 8px;
      .icon-close {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
      }
    }

    .message-box-content {
      // padding: 32px;
      padding: 24px 32px 32px;
    }
  }
}
</style>
